// extracted by mini-css-extract-plugin
export default {"container":"Footer_container__iICw7","btn":"Footer_btn__JIdlr","icons":"Footer_icons__vFgv7","social":"Footer_social__MfQNF"};